export default {
	data: () => ({
		snackbarActive: false,
		snackbarType: null,
	}),
	methods: {
		handleChangeRegistered() {
			this.setSnackbar();
		},
		async snackbarSave() {
			if (this.showRequestsModal) return;
			await this.$snackbar();
			await this.$nextTick();
			this.$snackbar({title: 'Your experiment has been saved.', btn: null, duration: 6000});
			this.snackbarType = 'save';
		},
		async setSnackbar() {
			// prevents doubling snackbar
			if (this.$store.state.salesGenomicSnackbarActive) {
				this.$bus.$emit(this.$bus.CLEAR_SNACKBAR);
				return this.$store.commit('setSalesGenomicSnackbarActive', false);
			}
			if (this.snackbarType === 'not-saved' && this.snackbarActive) return;
			await this.$snackbar();
			await this.$nextTick();
			this.$snackbar({title: 'Your experiment has not been saved.', btn: 'Save Now'});
			this.snackbarType = 'not-saved';
		},
		async snackBarCountryAvailability() {
			await this.$snackbar();
			await this.$nextTick();
			this.$snackbar({title: 'Content has changed due to country availability.', btn: null, duration: 6000});
			this.snackbarType = 'country-availability';
		},
		async snackBarExcludedProduct() {
			await this.$snackbar();
			await this.$nextTick();
			this.$snackbar({title: 'Content has been adjusted to selected products.', btn: null, duration: 6000});
			this.snackbarType = 'product-availability';
			/**
			 * TBD: race issues with this and setSnackbar causeing this snackbar to maintain setSnackbars duraion
			 * need to find a global fix, possibly condense all snackbars to one method that accepts parms
			 */
			setTimeout(() => {
				this.$snackbar();
			}, 6000);
		},
		async snackBarAddToCartError() {
      this.$root.$emit('showGlobalBanner', {
				title: 'Error adding product to cart.',
				body: 'Due to technical reasons, we were unable to add products to cart. Please try again.',
				version: 'error',
				btn: 'dismiss',
				btnEmits: 'closeGlobalBanner',
			});
			this.snackbarType = 'cart-error';
		},
	},
	created() {
		this.$root.$on('changeRegistered', this.handleChangeRegistered);
		this.$root.$on('saveWorkflowSuccess', this.snackbarSave);
		this.$root.$on('countryAvailabilityChanged', this.snackBarCountryAvailability);
		this.$root.$on('exclusionRuleApplied', this.snackBarExcludedProduct);
		this.$root.$on('addToCartError', this.snackBarAddToCartError);
	},
};
